<nav class="tab-box">     
    <div class="nav-content">         
        <button class={{classTab}} routerLink="/flujo-fondos" routerLinkActive="activa">Flujo de fondos</button>         
        <!--button class={{classTab}} routerLink="/botones" routerLinkActive="activa">Ejemplos de Botones</button>         
        <button class={{classTab}} routerLink="/loader" routerLinkActive="activa">Ejemplos de loader</button>    
        <button class={{classTab}} (click)="chooseMe(3)" [disabled]='selected==3'>Ejemplos de tabla</button>        
        <button class={{classTab}} (click)="chooseMe(4)" [disabled]='selected==4'>Ejemplos de alert</button>     
        <button class={{classLink}} (click)="abrir('https://angular.io/')" 
            placement="bottom" ngbTooltip="Angular.io">un enlace externo</button-->     
    </div>     
    <div>         
        <fa-icon (click)="dropMenu()" class="menu-icon"  [icon]="['fas', !ver? 'bars':'xmark']" ></fa-icon>     
    </div> 
</nav> 


<!-- Colocar el componente que se desea renderizar de forma singlepage
    elegir entre esta estrategia o la de rout link, no es recomendable combinarlas
-->     
<!--div class="tab-Content" *ngIf="selected==3">     
    <ejemplo-tablas></ejemplo-tablas> 
</div> 
<div class="tab-Content" *ngIf="selected==4">     
    <ejemplo-alert></ejemplo-alert> 
</div--> 